export default {"src":"/_next/static/media/youtube.aab54099.svg","height":12,"width":17};